export default __webpack_public_path__ + "static/media/plantbanner.d2afa109.png";